import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import { Box } from "@mui/material";
import Select from "react-select";
import {
  getUsersName,
  handleDatesSet,
  selectStyles,
  transformEventName,
} from "../../utils";

function SchoolCalendar({ cityProps, roomProps, calendarControls, stateData }) {
  const {
    cities,
    selectedCity,
    defaultSelectedCity,
    showDefaultCityRadios,
    handleCityChange,
    handleDefaultCityChange,
    handleSubmitDefaultCity,
  } = cityProps;

  const { rooms, selectedRooms, handleRoomChange } = roomProps;

  const {
    handleDateClick,
    handleEventClick,
    setIsDayGridMonth,
    setEvents,
    setStartDate,
    setEndDate,
  } = calendarControls;

  const {
    startDate,
    endDate,
    isDayGridMonth,
    role,
    zakupiteljType,
    authToken,
    transformedAllEventsSchoolCalendar,
    userData,
    allUsers,
  } = stateData;

  const selectedRoomOptions = rooms.filter((room) =>
    selectedRooms.includes(room.value)
  );

  return (
    <Box>
      <Box
        display="flex"
        className="sidebar-box"
        justifyContent="space-between"
        marginTop={20}
      >
        <div className="calendar-sidebar-container">
          {showDefaultCityRadios && (
            <div className="default-city-container">
              <p
                style={{
                  fontSize: 18,
                  color: "#5f6d7e",
                  fontWeight: 600,
                  fontFamily: "Inter",
                  marginBlockStart: 0,
                }}
              >
                Odaberi grad za kojeg želiš da ti se prvi prikazuje:
              </p>
              {cities.map((city, index) => (
                <div key={index} className="option-container">
                  <input
                    type="radio"
                    id={`default-city-${city.value}`}
                    name="default-city"
                    className="default-city-option"
                    value={city.value}
                    onChange={() =>
                      handleDefaultCityChange(city.value, city.label)
                    }
                    checked={defaultSelectedCity?.value === city.value}
                  />{" "}
                  <label
                    htmlFor={`default-city-${city.value}`}
                    style={{
                      fontSize: 15,
                      color: "#5f6d7e",
                      fontWeight: 400,
                      fontFamily: "Inter",
                    }}
                  >
                    {city.label}
                  </label>
                </div>
              ))}
              <button
                className="default-btn"
                onClick={() => handleSubmitDefaultCity()}
              >
                Spremi
              </button>
            </div>
          )}
          <br />
          <Select
            options={cities}
            styles={selectStyles}
            onChange={handleCityChange}
            className="selectCal"
            value={selectedCity}
            isSearchable={false}
            menuPortalTarget={document.body}
            components={{ IndicatorSeparator: () => null }}
          />
          <br />
          <Select
            options={rooms}
            styles={selectStyles}
            onChange={handleRoomChange}
            value={selectedRoomOptions}
            placeholder="Prikaži sobe"
            className="selectCal"
            isSearchable={false}
            isMulti
            menuPortalTarget={document.body}
            components={{ IndicatorSeparator: () => null }}
          />
          <br />
        </div>

        <Box flex="1 1 100%" ml="15px">
          <div className="fc">
            <FullCalendar
              height="75vh"
              plugins={[
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin,
                listPlugin,
              ]}
              headerToolbar={{
                left: "prev,today,next",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
              }}
              dateClick={
                role === "Referada" || zakupiteljType !== null
                  ? handleDateClick
                  : null
              }
              initialView="dayGridMonth"
              editable={false}
              selectable={true}
              datesSet={(info) => {
                const isMonthView = info.view.type === "dayGridMonth";
                setIsDayGridMonth(isMonthView);
                handleDatesSet(
                  info,
                  selectedRooms,
                  authToken,
                  setEvents,
                  setStartDate,
                  setEndDate,
                  startDate,
                  endDate
                );
              }}
              selectMirror={true}
              dayMaxEvents={true}
              select={
                (role === "Referada" || zakupiteljType !== null) &&
                ((info) => handleDateClick(info))
              }
              eventClick={handleEventClick}
              events={transformedAllEventsSchoolCalendar}
              eventContent={(data) => (
                <div
                  style={{
                    overflow: "hidden",
                    width: "100%",
                    minHeight: "18px",
                    height: "100%",
                    borderRadius: 4,
                    padding: 2,
                    backgroundColor:
                      data.event.extendedProps.userId === userData.id ||
                      data.event.extendedProps.supervisorId === userData.id
                        ? "#3eb489"
                        : "#cb9c2d",
                    boxSizing: "border-box",
                  }}
                >
                  {data.event._def.extendedProps.name
                    ? data.event._def.extendedProps.name
                    : userData.id ===
                          data.event._def.extendedProps.therapistId ||
                        userData.id ===
                          data.event._def.extendedProps.supervisorId
                      ? getUsersName(
                          allUsers,
                          data.event._def.extendedProps?.clientId,
                          data.event._def.extendedProps
                        )
                      : data.event._def.extendedProps?.therapistId
                        ? getUsersName(
                            allUsers,
                            data.event._def.extendedProps?.therapistId,
                            data.event._def.extendedProps
                          )
                        : data.event._def.extendedProps?.clientOutsideIPD
                          ? data.event._def.extendedProps?.clientOutsideIPD
                          : data.event._def.extendedProps?.supervisorId
                            ? getUsersName(
                                allUsers,
                                data.event._def.extendedProps?.supervisorId,
                                data.event._def.extendedProps
                              )
                            : transformEventName(
                                data.event._def.extendedProps.eventType
                              )}
                </div>
              )}
              slotMinTime="07:00:00"
              slotMaxTime="22:00:00"
              allDaySlot={false}
              eventMouseEnter={() => {}}
              eventMouseLeave={() => {}}
              slotLabelContent={(slotInfo) => {
                const hours = slotInfo.date.getHours();
                const minutes = slotInfo.date
                  .getMinutes()
                  .toString()
                  .padStart(2, "0");

                return (
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "#71717A",
                      fontFamily: "Inter",
                    }}
                  >
                    {`${hours}:${minutes}`}{" "}
                  </span>
                );
              }}
              slotLabelInterval={{ minutes: 30 }}
              dayHeaderContent={(info) => {
                const dayName = info.date
                  .toLocaleString("en-US", { weekday: "short" })
                  .toUpperCase();
                const date = info.date.getDate();
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "left",
                    }}
                  >
                    <div
                      style={{
                        color: "#71717A",
                        fontSize: "11px",
                        fontWeight: "700",
                        fontFamily: "Inter",
                      }}
                    >
                      {dayName}
                    </div>
                    {!isDayGridMonth ? (
                      <div
                        style={{
                          fontSize: "22px",
                          fontWeight: "500",
                          color: "#000000",
                          fontFamily: "Inter",
                        }}
                      >
                        {date}
                      </div>
                    ) : (
                      <div
                        style={{
                          height: "10px",
                        }}
                      ></div>
                    )}
                  </div>
                );
              }}
            />
          </div>
        </Box>
      </Box>
    </Box>
  );
}

export default SchoolCalendar;
